import React from 'react';
import { motion } from 'framer-motion';
import { TargetIcon, MapPinIcon, RefreshCwIcon } from 'lucide-react';
const phases = [{
  number: '1',
  title: 'ATRACCIÓN DE CONTRATOS',
  description: 'Segmentamos propietarios de casas con jardín en tu zona de servicio que han mostrado interés en servicios de mantenimiento premium.',
  bullets: ['No leads de $30.', 'Contratos de $200-$500 al mes.'],
  icon: TargetIcon
}, {
  number: '2',
  title: 'AUTORIDAD LOCAL',
  description: 'Te posicionamos en el Top 3 de Google Maps para las búsquedas de Landscaping en tu ciudad. Optimizamos tu perfil de Google Business con fotos de antes/después que venden solos.',
  bullets: [],
  icon: MapPinIcon
}, {
  number: '3',
  title: 'CONVERSIÓN A CONTRATO RECURRENTE',
  description: 'Diseñamos una oferta irresistible de "Mantenimiento Anual" que convierte clientes de una sola vez en ingresos mensuales predecibles. El sistema hace el seguimiento automático hasta que firman el contrato.',
  bullets: [],
  icon: RefreshCwIcon
}];
export function SystemSection() {
  return <section className="py-24 px-6 bg-carbon relative overflow-hidden" data-id="element-44">
      {/* Subtle emerald glow */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[600px] h-[600px] bg-emerald/5 blur-[150px] rounded-full pointer-events-none" data-id="element-45" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-47">
          <span className="text-emerald font-heading font-semibold tracking-wider uppercase text-sm mb-3 block" data-id="element-48">
            La Cura
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white text-balance" data-id="element-49">
            SISTEMA A.C.E.™ LANDSCAPING
          </h2>
        </motion.div>

        <div className="space-y-12" data-id="element-50">
          {phases.map((phase, index) => {
          const Icon = phase.icon;
          return <motion.div key={phase.number} initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="flex flex-col md:flex-row gap-6 md:gap-8 items-start bg-carbon-light border border-carbon-lighter p-8 rounded-2xl" data-id="element-51">
                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-emerald/10 border border-emerald/20 flex items-center justify-center" data-id="element-52">
                  <Icon className="w-8 h-8 text-emerald" data-id="element-53" />
                </div>

                <div className="flex-1" data-id="element-54">
                  <div className="flex items-center gap-3 mb-3" data-id="element-55">
                    <span className="bg-emerald text-white text-xs font-bold px-2 py-1 rounded font-heading" data-id="element-56">
                      FASE {phase.number}
                    </span>
                    <h3 className="font-heading text-xl md:text-2xl font-bold text-white" data-id="element-57">
                      {phase.title}
                    </h3>
                  </div>

                  <p className="font-body text-neutral-300 text-lg leading-relaxed mb-4" data-id="element-58">
                    {phase.description}
                  </p>

                  {phase.bullets.length > 0 && <ul className="space-y-2" data-id="element-59">
                      {phase.bullets.map((bullet, i) => <li key={i} className="flex items-center gap-2 text-gold font-medium font-body" data-id="element-60">
                          <div className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-61" />
                          {bullet}
                        </li>)}
                    </ul>}
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}